import useSWR from "swr";
import {Utils} from "../common/utils";

const clientConfigs = Utils.getEAIClientConfigs();

export interface UserPreferences {
    notification_frequency: "immediate" | "daily" | "weekly"
    notification_weekly_summary: boolean
}

export interface UserPreferencesResponse {
    data: {
        preferences: UserPreferences
    },
    result: {
        message: string,
        code: number
    }
}

export interface User {
    ruuid: string
    name: string
}

export interface UserResponse {
    data: User[]
}

export function useUserPreferences() {
    const {data, error, mutate} = useSWR<UserPreferencesResponse, Error>(`${clientConfigs.endpoint}/schools/${clientConfigs.school}/users/me/preferences`);

    return {
        data,
        error,
        mutate
    };
}

export function useUsers(schoolId?: string) {
    const {data, error, mutate} = useSWR<UserResponse, Error>(`${clientConfigs.endpoint}/schools/${schoolId || clientConfigs.school}/users`);

    return {
        data,
        error,
        mutate
    };
}